// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3vhwu","log":"ModalInventoryLogs_log__1rjH9","date":"ModalInventoryLogs_date__57VRd","userName":"ModalInventoryLogs_userName__7a2G8"};